export var WalletConnectionType;
(function (WalletConnectionType) {
    WalletConnectionType["MAGIC_LINK"] = "MAGIC_LINK";
    WalletConnectionType["METAMASK"] = "METAMASK";
    WalletConnectionType["MPC"] = "MPC";
    WalletConnectionType["EXTERNAL"] = "EXTERNAL";
})(WalletConnectionType || (WalletConnectionType = {}));
